import React from 'react';

import PropTypes from 'prop-types';

import style from './style.module.less';

export const LabelWithValue = ({ label, value }) => (
  <div className={style['label-with-value']}>
    <div className={style.label}>{label}</div>
    <div className={style.value}>{value}</div>
  </div>
);

LabelWithValue.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};
